import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Validators, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { BaseFilterComponent } from '../base-filter.component';
import { DateTimeFilterType } from '../../../../../core/services/api-services';
import { FilterType } from '../../../../../core/enums/filter-type';
import { Filter } from '../../../../../core/models/filter';

@Component({
  selector: 'app-date-time-filter',
  templateUrl: './date-time-filter.component.html',
  styleUrls: ['./date-time-filter.component.scss']
})
export class DateTimeFilterComponent extends BaseFilterComponent<DateTimeFilterType> implements OnInit {
  filterForm = new FormGroup({
    filterType: new FormControl(DateTimeFilterType.Equals, [Validators.required])
  });

  dateBetweenForm = new FormGroup({
    value: new FormControl('', [Validators.required]),
    value2: new FormControl('', [Validators.required]),
  });

  singleDateForm = new FormGroup({
    value: new FormControl('', [Validators.required]),
      value2: new FormControl(null)
  });

  filterOptions = this.getFilterOptions();
  currentFilter = new BehaviorSubject<DateTimeFilterType>(DateTimeFilterType.Equals);
  dateFilterBetween = DateTimeFilterType.Between;
  filterType: FilterType = FilterType.DateTime;

  constructor(
    private readonly formBuilder: FormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.currentValue
      .unsubscribeOnDestroy(this)
      .subscribe(value => {
        if (value) {
          this.filterChanged.emit({ filter: value, filterType: this.filterType, propertyName: this.propertyName });
          this.activeFilterField = value !== null;

          this.filterTypeControl.setValue(value.filterType);

          if (value.filterType !== DateTimeFilterType.Between) {
            this.dateSingleDateControl.setValue(value.values[0]);
          }
          else {
            this.dateBetweenValueControl.setValue(value.values[0]);
            this.dateBetweenValue2Control.setValue(value.values[1]);
          }
        }
      });

    if (this.initialValue) {
      this.currentValue.next(this.initialValue);
    }
  }

  clearFilter(): void {
    this.currentValue.next(null);
    this.activeFilterField = this.currentValue.value !== null;
    this.filterForm.reset();
    this.dateBetweenForm.reset();
    this.singleDateForm.reset();
  }

  getFilterOptions(): { value: number, translationKey: string }[] {
    const options: { value: number, translationKey: string }[] = [];

    Object.keys(DateTimeFilterType).filter((enumVal) => !isNaN(Number(enumVal))).forEach((enumVal: any) => {
      options.push({
        value: parseInt(enumVal, 10),
        translationKey: `GridTable.Filter.DateFilters.${DateTimeFilterType[enumVal]}`
      });
    });

    return options;
  }

  onFilterChange($event: MatSelectChange): void {
    this.currentFilter.next($event.value as DateTimeFilterType);
  }

  onSubmit($event): void {
    if (this.currentFilter.value !== DateTimeFilterType.Between) {
      // Trigger form validation for untouched fields
      this.singleDateForm.markAllAsTouched();

      if (this.singleDateForm.valid) {
        const model: Filter<DateTimeFilterType> = {
          filterType: this.filterTypeControl.value,
          values: [this.dateSingleDateControl.value, null] as any[],
          name: this.propertyName
        };

        this.currentValue.next(model);
      }
      else {
        $event?.stopPropagation();
      }
    }
    else {
      // Trigger form validation for untouched fields
      this.dateBetweenForm.markAllAsTouched();

      if (this.dateBetweenForm.valid) {
        const model: Filter<DateTimeFilterType> = {
          filterType: this.currentFilter.value,
          values: [this.dateBetweenValueControl.value, this.dateBetweenValue2Control.value] as any[],
          name: this.propertyName
        };

        this.currentValue.next(model);
      }
      else {
        $event?.stopPropagation();
      }
    }
  }

  onCancel(): void {
  }

  get dateSingleDateControl(): FormControl {
    return this.singleDateForm.controls.value as FormControl;
  }

  get dateBetweenValueControl(): FormControl {
    return this.dateBetweenForm.controls.value as FormControl;
  }

  get dateBetweenValue2Control(): FormControl {
    return this.dateBetweenForm.controls.value2 as FormControl;
  }

  get filterTypeControl(): FormControl {
    return this.filterForm.controls.filterType as FormControl;
  }
}
